import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { Toast } from 'primeng/toast';
import { ClaimStatus } from 'src/app/core/enums/claim-status.enum';
import { Pagination } from 'src/app/core/interfaces/pagination.interface';
import { LocalStorageServiceBase } from 'src/app/core/services/localStorage-serviceBase';
import AESEncryptDecryptService from 'src/app/core/utils/crypto';
import { Failure } from 'src/app/core/utils/failure';
import { AudiencesService } from 'src/app/features/audiences/services/audiences.service';
import { ClaimFilterModel } from 'src/app/features/claims/data/models/claim-filter.model';
import { ClaimsPaginationParamsModel } from 'src/app/features/claims/data/models/claim-pagination-params.model';
import { DeleteClaimModel } from 'src/app/features/claims/data/models/delete-claim.model';
import { UpdateClaimStatusModel } from 'src/app/features/claims/data/models/update-claim-status.model';
import { UpdateClaimColectiveConciliatorModel } from 'src/app/features/claims/data/models/update-colective.model';
import { ClaimMultiEntity } from 'src/app/features/claims/domain/entities/claim-multi.entity';
import { ClaimPagination } from 'src/app/features/claims/domain/entities/claim-pagination.entity';
import { ClaimEntity } from 'src/app/features/claims/domain/entities/claim.entity';
import { UpdateClaimConciliatorEntity } from 'src/app/features/claims/domain/entities/update-claim-conciliator.entity';
import { UpdateClaimStatusEntity } from 'src/app/features/claims/domain/entities/update-claim-satus.entity';
import { DeleteMultiClaimUseCase } from 'src/app/features/claims/domain/usecases/delete-multi-claim.usecase';
import { GetMultiSingleClaimsUseCase } from 'src/app/features/claims/domain/usecases/get-claim-multi-single.usecase';
import { UpdateClaimMultiConciliatorUseCase } from 'src/app/features/claims/domain/usecases/update-claim-multi-conciliator.usecase';
import { UpdateMultiClaimStatusUseCase } from 'src/app/features/claims/domain/usecases/update-multi-status.usecase';
import { FilterServiceService } from 'src/app/features/claims/services/filter-service.service';
import { UserData } from 'src/app/features/user/domain/entities/user-data.entity';
import { GetAllConciliatorsUseCase } from 'src/app/features/user/domain/usecases/get-all-conciliators.usecase';

@Component({
  selector: 'app-claims-multi-single-table',
  templateUrl: './claims-multi-single-table.component.html',
  styleUrls: ['./claims-multi-single-table.component.css'],
  providers: [MessageService, Toast, ConfirmationService],
})
export class ClaimsMultiSingleTableComponent implements OnInit {
  public homeView: boolean = false;
  public dialog: string = '';
  public claimExpedient: string = '';

  public pagination: Pagination = {
    totalQuantity: 0,
    numberOfPages: 0,
    itemsPerPage: 5,
    actualPage: 1,
  };
  paginatedData: ClaimPagination | undefined = undefined;

  public skeleton: boolean = false;
  public skeletons: any = [{}, {}, {}, {}, {}];

  public filters?: ClaimFilterModel;

  public userClaims?: any[];
  public selectedClaimId?: string;
  public claim?: ClaimEntity;

  public conciliators: UserData[] = [];
  newConciliatorClaimUpdate?: UpdateClaimColectiveConciliatorModel;

  public status: string[] = [
    ClaimStatus.PENDING,
    ClaimStatus.REFUSED,
    ClaimStatus.ADMITTED,
    ClaimStatus.AUDIENCE_SET,
    ClaimStatus.IN_INTERNAL_PROCESS,
    ClaimStatus.FINALIZED,
  ];
  public originalStatus?: string;

  newStatusClaimUpdate?: UpdateClaimStatusModel;

  audienciaDialogVisible: boolean = false;
  claimSelected?: ClaimMultiEntity;

  audienceId?: string;
  dateAudience?: Date;
  timeAudience?: string;
  minuteDialogVisible: boolean = false;
  isLoadingSpinner: boolean = false;

  haveResults: boolean = true;

  public rol?: string;
  public userId?: string;

  public items: MenuItem[] = [
    {
      label: 'Ver reclamo',
      icon: 'pi pi-eye',
      command: () => {
        this.viewClaim();
      },
    },
  ];

  private AES = new AESEncryptDecryptService();

  constructor(
    private router: Router,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private getAllConciliatorsUseCase: GetAllConciliatorsUseCase,
    private localStorageService: LocalStorageServiceBase,
    private getMultiSingleClaimsUsecase: GetMultiSingleClaimsUseCase,
    private updateClaimConciliatorUseCase: UpdateClaimMultiConciliatorUseCase,
    private updateClaimStatusUseCase: UpdateMultiClaimStatusUseCase,
    private deleteClaimUseCase: DeleteMultiClaimUseCase,
    private filterService: FilterServiceService
  ) {}

  ngOnInit() {
    this.userId = this.AES.decrypt(
      this.localStorageService.loadStorageData('user_id')
    );
    this.rol = this.AES.decrypt(
      this.localStorageService.loadStorageData('user_rol')
    );
    if (this.rol == 'Administrador') this.getAllConciliators();
    if (this.router.url.includes('main/home')) {
      this.homeView = true;
    }
    const savedFilters = this.filterService.getFilters('multi-filters');
    if (
      savedFilters &&
      !this.homeView &&
      localStorage.getItem('multi-response') === 'succes'
    ) {
      this.filters = savedFilters;
      this.initClaims();
    } else {
      this.filterService.clear('multi-filters');
      this.initClaims();
    }
  }

  //CLAIMS
  async initClaims() {
    this.skeleton = true;
    let params;
    if (
      this.rol == 'Administrador' ||
      this.rol == 'Conciliador' ||
      this.rol == 'Miembro de la comisión'
    ) {
      params = new ClaimsPaginationParamsModel(
        this.pagination.actualPage,
        this.pagination.itemsPerPage,
        undefined,
        this.filters,
        undefined,
        this.userId
      );
    } else {
      params = new ClaimsPaginationParamsModel(
        this.pagination.actualPage,
        this.pagination.itemsPerPage,
        undefined,
        this.filters,
        this.userId,
        undefined
      );
    }
    let result;
    result = await this.getMultiSingleClaimsUsecase.execute(params);
    if (result instanceof Failure) {
      localStorage.setItem('multi-response', 'error');
      this.skeleton = false;
      this.haveResults = false;
      return;
    }
    if (result) {
      localStorage.setItem('multi-response', 'succes');
      this.haveResults = true;
      this.userClaims = result.response;
      this.pagination.totalQuantity = result.totalQuantity;
      setTimeout(() => {
        this.skeleton = false;
      }, 200);
    }
  }

  selectClaim(
    id: string,
    audienceId: string,
    dateAudience: Date,
    timeAudience: string,
    claimExpendient: string
  ): void {
    this.selectedClaimId = id;
    this.audienceId = audienceId;
    this.dateAudience = dateAudience;
    this.timeAudience = timeAudience;
    this.claimExpedient = claimExpendient;
  }

  viewClaim(): void {
    if (this.selectedClaimId) {
      this.router.navigate(['/main/claims', this.selectedClaimId]);
    }
  }

  editClaim(): void {
    if (
      this.selectedClaimId &&
      (this.rol === 'Empleador' || this.rol === 'Representante gremial')
    ) {
      this.router.navigate(['main/claim/update-multi', this.selectedClaimId]);
    }
  }

  showdeleteClaim(status: string) {
    this.dialog = 'deleteClaim';
    setTimeout(() => {
      this.confirmationService.confirm({
        key: this.dialog,
        header: 'Eliminar reclamo',
        message: `¿Está seguro de que desea eliminar el reclamo N° ${this.claimExpedient}? Se perderán todos los datos.`,
        accept: () => {
          this.deleteClaim(status);
        },
        reject: () => {
          this.initClaims();
        },
      });
    });
  }

  async deleteClaim(status: string): Promise<void> {
    if (status !== 'Pendiente' && status !== 'Borrador') {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Su reclamo esta en curso, no es posible eliminar',
      });
      return;
    }
    let claimDeleteEntity = new DeleteClaimModel(this.selectedClaimId!);
    let result = await this.deleteClaimUseCase.execute(claimDeleteEntity);
    if (result instanceof Failure) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: result.message,
      });
      return;
    }
    this.messageService.add({
      severity: 'success',
      summary: 'Reclamo eliminado',
      detail: 'Su reclamo se elimino exitosamente.',
    });
    this.initClaims();
  }

  //AUDIENCE
  setNewAudience() {
    this.audienciaDialogVisible = true;
  }
  returnSelectedClaim(claim: ClaimMultiEntity) {
    this.claimSelected = Object.assign({}, claim);
  }
  get transformedClaim(): Partial<ClaimEntity> {
    if (!this.claimSelected) return {};
    return {
      ...this.claimSelected,
      selecterObjectOfClaim: Array.isArray(
        this.claimSelected?.selecterObjectOfClaim
      )
        ? this.claimSelected.selecterObjectOfClaim.join(', ')
        : this.claimSelected?.selecterObjectOfClaim,

      extraDocumentationPdf: Array.isArray(
        this.claimSelected?.extraDocumentationPdf
      )
        ? this.claimSelected.extraDocumentationPdf.join(', ')
        : this.claimSelected?.extraDocumentationPdf,
    };
  }
  cancel(event: any) {
    this.claimSelected = undefined;
    this.audienciaDialogVisible = false;
    this.minuteDialogVisible = false;
  }
  createAudienceOk(event: any) {
    this.initClaims();
  }
  handleShowMessage(event: {
    severity: string;
    summary: string;
    detail: string;
  }) {
    this.messageService.add({
      severity: event.severity,
      summary: event.summary,
      detail: event.detail,
    });
  }

  createMinute() {
    this.minuteDialogVisible = true;
  }

  refreshGetAll() {
    location.reload();
  }

  handleLoadingChange(loading: boolean) {
    this.isLoadingSpinner = loading;
  }

  //CONCILIATOR
  async getAllConciliators(): Promise<void> {
    const result = await this.getAllConciliatorsUseCase.execute();
    if (result instanceof Failure) {
      return;
    }
    const noAssignedOption: UserData = {
      id: '',
      name: 'No asignado',
      lastName: '',
      rol: '',
      cuil: '',
      gender: '',
      birthDate: new Date(),
      province: '',
      phone: '',
      email: '',
      civilStatus: '',
      city: '',
      street: '',
      number: '',
      floorApartment: '',
      postalCode: 0,
      company: '',
      companyCuil: '',
      dni: '',
      neighborhood: '',
      toJson: function (): Map<string, any> {
        throw new Error('Function not implemented.');
      },
    };
    this.conciliators = [noAssignedOption, ...result];
  }

  isConciliatorChangeAllowed(status: string): boolean {
    const allowedStatuses = ['Pendiente', 'Admitido'];
    return allowedStatuses.includes(status);
  }

  updateConciliatorCheck(event: any, idClaim: string) {
    this.dialog = 'updateConciliator';
    const conciliatorName = event.value.id
      ? `${event.value.name} ${event.value.last_name}`
      : 'eliminar el conciliador actual';
    setTimeout(() => {
      this.confirmationService.confirm({
        key: this.dialog,
        header: 'Actualizar conciliador',
        message: `¿Está seguro de que desea ${
          event.value.id ? 'actualizar el conciliador actual por' : ''
        } ${conciliatorName}?`,
        accept: () => {
          this.newConciliatorClaimUpdate =
            new UpdateClaimColectiveConciliatorModel(
              idClaim,
              event.value.id ? event.value.id : 'No asignado'
            );
          this.updateClaimConciliator(this.newConciliatorClaimUpdate);
        },
        reject: () => {
          this.initClaims();
        },
      });
    });
  }

  async updateClaimConciliator(
    claim: UpdateClaimConciliatorEntity
  ): Promise<void> {
    let result = await this.updateClaimConciliatorUseCase.execute(claim);
    if (result instanceof Failure) {
      this.messageService.add({
        severity: 'error',
        summary: 'Ocurrió un problema.',
        detail: 'Conciliador no actualizado.',
        life: 900,
      });
      this.initClaims();
      return;
    }
    this.messageService.add({
      severity: 'success',
      summary: 'Conciliador actualizado',
      detail: 'El conciliador se actualizó exitosamente.',
    });
    setTimeout(() => {
      this.initClaims();
    }, 1500);
  }

  getClassForRole(rol: string): string {
    switch (rol) {
      case 'Trabajador':
        return 'status-pending';
      case 'Empleador':
        return 'status-audience-set';
      case 'Representante gremial':
        return 'status-admited';
      default:
        return '';
    }
  }

  //STATE
  getStatusClass(status: string): string {
    switch (status) {
      case ClaimStatus.DRAFT:
        return 'status-draft';
      case ClaimStatus.PENDING:
        return 'status-pending';
      case ClaimStatus.REFUSED:
        return 'status-refused';
      case ClaimStatus.FINALIZED:
        return 'status-finalized';
      case ClaimStatus.IN_INTERNAL_PROCESS:
        return 'status-in-internal-process';
      case 'Tramite Interno':
        return 'status-in-internal-process';
      case 'En trámite interno':
        return 'status-in-internal-process';
      case ClaimStatus.AUDIENCE_SET:
        return 'status-audience-set';
      case 'Audiencia fijada':
        return 'status-audience-set';
      case ClaimStatus.ADMITTED:
        return 'status-admited';
      default:
        return '';
    }
  }

  getStatusClassForPrincipalView(status: string): string {
    switch (status) {
      case ClaimStatus.DRAFT:
        return 'status-draft-principal';
      case ClaimStatus.PENDING:
        return 'status-pending-principal';
      case ClaimStatus.REFUSED:
        return 'status-refused-principal';
      case ClaimStatus.FINALIZED:
        return 'status-finalized-principal';
      case ClaimStatus.IN_INTERNAL_PROCESS:
        return 'status-in-internal-process-principal';
      case 'Tramite Interno':
        return 'status-in-internal-process-principal';
      case 'En trámite interno':
        return 'status-in-internal-process-principal';
      case ClaimStatus.AUDIENCE_SET:
        return 'status-audience-set-principal';
      case 'Audiencia fijada':
        return 'status-audience-set-principal';
      case ClaimStatus.ADMITTED:
        return 'status-admited-principal';
      case ClaimStatus.ADMITTED:
        return 'status-admited';
      default:
        return '';
    }
  }

  dropdownClick(claim: any) {
    this.updateStatusOptionsByStatusClaim(claim.status);
    this.originalStatus = claim.status;
    this.selectedClaimId = claim._id;
  }

  updateStatusOptionsByStatusClaim(status: string) {
    switch (status) {
      case ClaimStatus.PENDING:
        this.status = [ClaimStatus.REFUSED, ClaimStatus.ADMITTED];
        break;
      case ClaimStatus.IN_INTERNAL_PROCESS:
        this.status = [ClaimStatus.FINALIZED];
        break;
      case 'Tramite Interno':
        this.status = [ClaimStatus.FINALIZED];
        break;
      case ClaimStatus.AUDIENCE_SET:
        this.status = [ClaimStatus.IN_INTERNAL_PROCESS];
        break;
      case 'Audiencia Fijada':
        this.status = [ClaimStatus.IN_INTERNAL_PROCESS];
        break;
      case ClaimStatus.FINALIZED:
        this.status = [ClaimStatus.IN_INTERNAL_PROCESS];
        break;
      default:
        this.status = [];
        break;
    }
  }

  claimDiffDate(claimDate: Date): boolean {
    const now = new Date();
    const diffInMs = now.getTime() - new Date(claimDate).getTime();
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
    return diffInDays <= 15;
  }

  updateStatusCheck(event: any) {
    this.dialog = 'updateStatus';
    setTimeout(() => {
      this.confirmationService.confirm({
        key: this.dialog,
        header: 'Actualizar estado',
        message: `¿Está seguro de que desea actualizar el estado del reclamo?`,
        accept: () => {
          this.newStatusClaimUpdate = new UpdateClaimStatusModel(
            this.selectedClaimId!,
            event.value
          );
          this.updateClaimStatus(this.newStatusClaimUpdate);
        },
        reject: () => {
          this.initClaims();
        },
      });
    });
  }

  async updateClaimStatus(claim: UpdateClaimStatusEntity): Promise<void> {
    let result = await this.updateClaimStatusUseCase.execute(claim);
    if (result instanceof Failure) {
      this.messageService.add({
        severity: 'error',
        summary: 'Ocurrió un problema.',
        detail: 'Estado no actualizado.',
        life: 900,
      });
      this.initClaims();
      return;
    }
    this.messageService.add({
      severity: 'success',
      summary: 'Estado actualizado',
      detail: 'El estado se actualizó exitosamente.',
    });
    this.initClaims();
  }

  selectAmountItems(status: string) {
    const labels = new Set(this.items.map((item) => item.label));

    const shouldAdd: { label: string; icon: string; command: () => void }[] =
      [];
    const shouldRemove: string[] = [];

    const isAdminOrConciliator =
      this.rol === 'Administrador' || this.rol === 'Conciliador';
    const isEmployer =
      this.rol === 'Empleador' || this.rol === 'Representante gremial';

    if (
      (status === ClaimStatus.PENDING || status === ClaimStatus.DRAFT) &&
      isEmployer
    ) {
      if (!labels.has('Eliminar reclamo')) {
        shouldAdd.push({
          label: 'Eliminar reclamo',
          icon: 'pi pi-trash',
          command: () => this.showdeleteClaim(status),
        });
      }
      if (!labels.has('Editar reclamo')) {
        shouldAdd.push({
          label: 'Editar reclamo',
          icon: 'pi pi-pencil',
          command: () => this.editClaim(),
        });
      }
    } else {
      shouldRemove.push('Eliminar reclamo', 'Editar reclamo');
    }

    shouldRemove.push('Fijar audiencia', 'Fijar nueva audiencia');
    if (
      (status === ClaimStatus.ADMITTED ||
        status === ClaimStatus.IN_INTERNAL_PROCESS ||
        status === ClaimStatus.AUDIENCE_SET ||
        status === 'Audiencia fijada' ||
        status === 'En trámite interno' ||
        status === 'Tramite interno') &&
      isAdminOrConciliator
    ) {
      const labelAudience =
        status === ClaimStatus.ADMITTED
          ? 'Fijar audiencia'
          : 'Fijar nueva audiencia';

      shouldAdd.push({
        label: labelAudience,
        icon: 'pi pi-calendar-plus',
        command: () => this.setNewAudience(),
      });
    }

    shouldRemove.push('Subir acta');

    this.items = this.items.filter(
      (item) => !shouldRemove.includes(item.label!)
    );
    this.items.push(...shouldAdd);
  }

  verificateAudienceDate(): boolean {
    if (!this.dateAudience) return false;
    const now = new Date();
    const audienceDateTime = new Date(this.dateAudience);
    if (this.timeAudience) {
      const [hours, minutes] = this.timeAudience.split(':').map(Number);
      audienceDateTime.setHours(hours, minutes, 0, 0);
    }
    return now > audienceDateTime;
  }

  //TABLE
  changePage(event: any) {
    this.pagination.actualPage = event.page + 1;
    this.pagination.itemsPerPage = event.rows;
    this.skeleton = true;
    this.initClaims();
  }

  onFiltersApplied(filters: ClaimFilterModel) {
    this.filters = filters;
    this.pagination.actualPage = 1;
    this.filterService.setFilters(filters, 'multi-filters');
    this.initClaims();
  }

  onFilterCancel(): void {
    this.pagination.actualPage = 1;
    this.filters = undefined;
    this.filterService.clear('multi-filters');
    this.initClaims();
  }
}
